class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {
  !!!win["lang"] && (win["lang"] = "en");
  document.documentElement.lang = win["lang"];

  !!!win["bmToken"] && (win["bmToken"] = import.meta.env.VITE_CLIENT_TKN);

  !!!win["cem_key"] && (win["cem_key"] = import.meta.env.VITE_CEM_K);
  !!!win["apigee_bm_x_api_key"] && (win["apigee_bm_x_api_key"] = import.meta.env.VITE_APIGEE_BM_X_APIK);
  !!!win["cem_public_key"] && (win["cem_public_key"] = import.meta.env.VITE_CEM_CLK_PK);
  !!!win["BM_CI"] && (win["BM_CI"] = import.meta.env.VITE_BM_CI);
  !!!win["BM_CS"] && (win["BM_CS"] = import.meta.env.VITE_SI_BM_CS);

  !!!win["env_variable"] && (win["env_variable"] = "SIT")
  !!!win["base_portal_url"] && (win["base_portal_url"] = "http://ssta004:8080");
  
  !!!win["apigee_base_api_url"] && (win["apigee_base_api_url"] = "https://apisit.mobily.com.sa/api");
  !!!win["apigee_bm_base_url"] && (win["apigee_bm_base_url"] = "https://apisit.mobily.com.sa");
  !!!win["mixpanel_token"] && (win["mixpanel_token"] = import.meta.env.VITE_MIXPANEL_TKN);
  !!!win["mixpanel_enabled"] && (win["mixpanel_enabled"] = 'true');
  !!!win["mixpanel_url"] && (win["mixpanel_url"] = "http://ssta004:8080/MobilyTheme4Resources/js/mixpanel-tracker.js");
  !!!win["por_redk"] && (win["por_redk"] = import.meta.env.VITE_POR_REDK);
  !!!win["trans_id"] && (win["trans_id"] = import.meta.env.VITE_TRANS_ID);
  !!!win['errorPageUrl'] && (win['errorPageUrl'] = `http://ssta004:8080/wps/portal/web/personal/store/error`);
  !!!win["branch_radius"] && (win["branch_radius"] = "5");
}


export default localhostSettings;
